<template>
	<div class="bmcx hello">
		<div class="queryBox" :class="TENANTID==0?'queryBoxHeight':''">
			<div class="queryBox-title">请选择查询类型</div>
			<div class="overallLeft queryValue">
				<div class="overallCenter" :class="ValueType==1?'query-Selected':''"
					@click="placeholderNmae='请输入作品编号',ValueType=1">学生获奖<br />查询</div>
				<div class="overallCenter" :class="ValueType==2?'query-Selected':''"
					@click="placeholderNmae='请输入实践证书编号',ValueType=2">实践证书<br />查询</div>
				<div class="overallCenter" :class="ValueType==3?'query-Selected':''" @click="ValueType=3">教师证书<br />查询</div>
				<!-- <div class="overallCenter" :class="ValueType==4?'query-Selected':''" @click="ValueType=4">报名结果<br />查询</div> -->
			</div>
			<!-- <template v-if="ValueType==1">
				<div class="queryBox-title">选择查询方式</div>
				<div class="overallLeft queryValue queryValue2">
					<div class="overallCenter" :class="ValueSearchType==1?'query-Selected':''" @click="ValueSearchType=1">作品编号查询
					</div>
					<div class="overallCenter" :class="ValueSearchType==2?'query-Selected':''" @click="ValueSearchType=2">身份证号查询
					</div>
				</div>
			</template> -->

			<div class="input_box inputwidth input_box_border" v-if="ValueType==1">
				<div class="input_panel" v-if="ValueSearchType==1">
					<van-field v-model="code" input-align="left" label="" :colon="true" :placeholder="placeholderNmae"
						maxlength="23" />
				</div>
				<template v-else>
					<div class="input_panel">
						<van-icon name="arrow-down" />
						<van-field v-model="provinceAbbr" input-align="left" label="" :colon="true" placeholder="请选择所在省份" readonly
							@click="isOpen=true" />
					</div>
					<div class="input_panel">
						<van-field v-model="idCard" input-align="left" label="" :colon="true" placeholder="请输入学生身份证号"
							maxlength="18" />
					</div>
					<div class="input_panel">
						<van-field v-model="name" input-align="left" label="" :colon="true" placeholder="请输入学生姓名" maxlength="20" />
					</div>
				</template>

			</div>
			<div class="input_box inputwidth input_box_border" v-if="ValueType==2">
				<div class="input_panel">
					<van-icon name="arrow-down" />
					<van-field v-model="provinceAbbr" input-align="left" label="" :colon="true" placeholder="请选择所在省份" readonly
						@click="isOpen=true" />
				</div>
				<div class="input_panel">
					<van-field v-model="code" input-align="left" label="" :colon="true" :placeholder="placeholderNmae"
						maxlength="23" />
				</div>
			</div>
			<div class="input_box inputwidth input_box_border" v-if="ValueType==3">
				<!-- <div class="input_panel">
					<van-field v-model="tel" input-align="left" label="" :colon="true" placeholder="请输入手机号" maxlength="18" />
				</div>
				<div class="input_panel">
					<van-field v-model="teacherName" input-align="left" label="" :colon="true" placeholder="请输入教师姓名"
						maxlength="20" />
				</div> -->
				<div class="input_panel">
					<van-field v-model="certNo" input-align="left" label="" :colon="true" placeholder="请输入教师证书编号" />
				</div>
			</div>
			<div class="input_box inputwidth input_box_border" v-if="ValueType==4">
				<div class="input_panel">
					<van-icon name="arrow-down" />
					<van-field v-model="activityname" input-align="left" label="" :colon="true" placeholder="请选择您报名的活动" readonly
						@click="isOpenActivity=true" />
				</div>
				<div class="input_panel">
					<van-field v-model="idCard" input-align="left" label="" :colon="true" placeholder="请输入学生身份证号" maxlength="18" />
				</div>
				<div class="input_panel">
					<van-field v-model="name" input-align="left" label="" :colon="true" placeholder="请输入学生姓名" maxlength="20" />
				</div>
			</div>
		</div>
		<div class="overallCenter btn btn-Selected" @click="sqlist">
			立即查询
		</div>
		<van-popup v-model="isOpen" position="bottom">
			<van-picker show-toolbar :columns="options" @cancel="isOpen = false "  @confirm="conCity"/>
		</van-popup>
		<van-popup v-model="isOpenActivity" position="bottom">
			<van-picker show-toolbar :columns="swActivity" @cancel="isOpenActivity = false" @confirm="conActivity">
				<template #option="option">
					<div>{{option.name}}</div>
				</template>
			</van-picker>
		</van-popup>


		<div v-if="issq" style="margin:20px 0">
			<p>{{list.length==0?(ValueType==3?'抱歉，暂未查询到证书信息':'抱歉，暂未查询到报名信息'):'已为你查询到的结果如下'}}</p>
		</div>
		<van-loading style="margin-top:15px" v-if="loading" size="16px" color="#1989fa">数据查询中...</van-loading>
		<div :style="list.length==0?'padding-bottom:50px':''">
			<template v-if="ValueType==3">
				<ul v-for="(item,index) in list" :key="index">
					<li class="worksLi">
						<p style="font-size:16px;line-height: 40px;">{{item.activityName}}</p>
						<el-descriptions title="" :column="1" border style="margin:10px auto;padding-bottom: 20px;">
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="教师姓名">{{item.teacherName}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="所在单位">{{item.teacherCompany}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="指导学生总数">{{item.workCount}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="指导最高奖项">{{item.studentTopPrize | prizeName}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="最高获奖学生名称"
								v-if="item.works.length>0">{{item.works[0].babyName}}等{{item.works.length}}名学生获得{{item.studentTopPrize | prizeName}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="证书编号">{{item.certNo}}</el-descriptions-item>
						</el-descriptions>
					</li>
				</ul>
			</template>
			<template v-else>
				<ul v-for="(item,index) in list" :key="index">
					<li class="worksLi">
						<p style="font-size:16px;line-height: 40px;">{{item.activityName}}</p>
						<el-descriptions title="" :column="1" border style="margin:10px auto;padding-bottom: 20px;">
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="主体类型"
								v-if="item.mainBodyType==2">
								团体
							</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="选手姓名">{{item.babyName}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="就读学校"
								v-if="item.schoolName">{{item.schoolName}}</el-descriptions-item>
							<!-- <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="指导教师">{{item.teacherName}}</el-descriptions-item> -->
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="报名时间">{{item.addTime}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass"
								label="参赛专业">{{item.majorName}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="参赛组别"
								v-if="item.mainBodyType==1">{{item.groupName}}</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="作品名称">
								{{item.name}}
								<span @click="onPreview(item)" v-if="item.name" style="color: #16d77a;">(查看作品)</span>
							</el-descriptions-item>
							<el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="获奖结果" v-if="ValueType!==4">
								{{ item.isDismissalPrize == 1?'取消成绩':item.worksType==3?'谢谢参与': item.prizeName }}
							</el-descriptions-item>
							<!-- <el-descriptions-item v-if="ValueType==2" labelClassName="labelclass" contentClassName="contentClass" label="证书编号">{{item.certNo}}</el-descriptions-item> -->
							<!-- <el-descriptions-item labelClassName="labelclass" contentClassName="contentClass" label="参赛地区">
								{{item.channelName?item.channelName:'个人报名'}}
							</el-descriptions-item> -->
						</el-descriptions>
					</li>
					<!-- <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="imageUrl"/> -->
				</ul>
			</template>
		</div>
		<!-- <img v-if="TENANTID==0" class="douyin_img" src="../../assets/images/douyin1.jpg" alt=""> -->
		<van-popup v-model="showViewer" class="photo-tags2" closeable position="bottom"
			:style="{ height: '100%', width: '100%' }" @close="showViewer=false">
			<div class="filelist">
				<div class="filelist-title">查看文件</div>
				<div class="" v-for="(time,index) in imageUrl" :key="index">
					<div class="overallBetween filelist-card">
						<div class="overallLeft">
							<div class="filelist-card-name">{{time.fileType | fileTypeName}}:</div>
							<div class="filelist-card-value">{{time.fileName}}</div>
						</div>
						<div class="filelist-card-btn" @click="getcheck(time)">查看</div>
					</div>
				</div>
			</div>
		</van-popup>
		<van-popup v-model="checkType" class="photo-tags" closeable position="bottom"
			:style="{ height: '100%', width: '100%' }" @close="beforeCloseHandler(checkData.fileType)">
			<div class="show-photo-tags">
				<img v-if="checkData.fileType == 1" :src="checkData.fileUrl" alt="" />
				<audio ref="audioPlayer" v-if="checkData.fileType == 2" width="100%" height="200" controls
					:src="checkData.fileUrl"></audio>
				<video ref="videoPlayer" v-if="checkData.fileType == 3" width="100%" height="200" controls
					:src="checkData.fileUrl"></video>
				<p style="text-align: center; margin-top: 20px">
					<a style="font-size: 18px; color: #16d77a" v-if="checkData.fileType == 4" :href="checkData.fileUrl">
						点击查看文档类作品
					</a>
				</p>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import {
		getWorksMsg,
		getcertsQuery,
		getWorksDetailsByH5,
		getWorksCertificateByH5
	} from "@/utils/api/home";
	import {
		getPageActivity
	} from "@/utils/api/home";
	import ElImageViewer from "element-ui/packages/image/src/image-viewer";
	import {
		getfileTypeArr
	} from "@/utils/tool";
	import {
		localStorageGetItem
	} from "@/utils/auth";
	import { wxlogin } from "@/utils/mixin/wxlogin";
	import { signature } from "@/utils/mixin/wx-js-sdk-signature";
	export default {
		name: 'bmcx',
		mixins: [wxlogin,signature],
		components: {
			ElImageViewer
		},
		data() {
			return {
				loading: false,
				placeholderNmae: '请输入作品编号',
				value: '',
				issq: false,
				list: [],
				ValueType: 1,
				ValueSearchType: 1,
				imageUrl: [],
				showViewer: false,
				checkType: false,
				checkData: {},
				TENANTID: 0,
				isOpen: false,
				isOpenActivity: false,
				/* activityId	integer($int32)
				活动id				
				code	string
				证书编号				
				idCard	string
				身份证号				
				name	string
				学生或老师姓名				
				provinceAbbr	string
				所在省份缩写				
				type	integer($int32)
				查询类型 1-获奖证书 2-实践证书 3-教师证书 4报名结果查询，这里只能使用1,2
			 */
				activityId: '',
				activityname: '',
				provinceAbbr: '',
				code: '',
				idCard: "",
				name: '',
				type: '',
				tel: '',
				teacherName: '',
				certNo:'',      // 证书编号
				swActivity: [], //活动
				options: [{
						text: '京'
					},
					{
						text: '摄'
					},
					{
						text: '造'
					},
					{
						text: '设'
					},
					{
						text: '中'
					},
					{
						text: '儿'
					},
					{
						text: '陶'
					},
					{
						text: '国'
					},
					{
						text: '黑'
					},
					{
						text: '鲁'
					},
					{
						text: '青'
					},
					{
						text: '陕'
					},
					{
						text: '闽'
					},
					{
						text: '鄂'
					},
					{
						text: '辽'
					},
					{
						text: '赣'
					},
					{
						text: '贵'
					},
					{
						text: '豫'
					},
					{
						text: '藏'
					},
					{
						text: '苏'
					},
					{
						text: '粤'
					},
					{
						text: '皖'
					},
					{
						text: '甘'
					},
					{
						text: '琼'
					},
					{
						text: '澳'
					},
					{
						text: '湘'
					},
					{
						text: '港'
					},
					{
						text: '渝'
					},
					{
						text: '浙'
					},
					{
						text: '津'
					},
					{
						text: '沪'
					},
					{
						text: '桂'
					},
					{
						text: '晋'
					},
					{
						text: '新'
					},
					{
						text: '川'
					},
					{
						text: '宁'
					},
					{
						text: '吉'
					},
					{
						text: '台'
					},
					{
						text: '冀'
					},
					{
						text: '云'
					},
					{
						text: '蒙'
					},
				],
			};
		},
		filters: {
			fileTypeName(e) {
				let name = '';
				e = e + ''
				switch (e) {
					case '1':
						name = '图片文件';
						break;
					case '2':
						name = '音频文件';
						break;
					case '3':
						name = '视频文件';
						break;
					case '4':
						name = '文档文件';
						break;
				}
				return name
			},
			prizeName(e) {
				let name = '';
				e = e + ''
				switch (e) {
					case '校外实践证书':
						name = '校外实践证书';
						break;
					case '等待成绩发布':
						name = '等待成绩发布';
						break;
					case '1':
						name = '一等奖';
						break;
					case '2':
						name = '二等奖';
						break;
					case '3':
						name = '三等奖';
						break;
					case '4':
						name = '优秀奖';
						break;
					default:
						name = '谢谢参与';
				}
				return name
			}
		},
		async mounted() {
			this.TENANTID = localStorageGetItem("TENANT-ID") || "0";
		},
		watch: {
			ValueType(newValue, oldValue) {
				this.reset()
				if (newValue == 4) {
					this.onLoadActivity()
				}
			},
			ValueSearchType(newValue){
				this.reset()
			},
		},
		methods: {
			reset() {
				this.activityId = ''
				this.activityname = ''
				this.provinceAbbr = ''
				this.code = ''
				this.idCard = ''
				this.name = ''
				this.teacherName = ''
				this.tel = ''
				this.issq = false
				this.list = []
			},
			conActivity(options) {
				this.activityId = options.id
				this.activityname = options.name
				this.isOpenActivity = false
				console.log(options)
			},
			conCity(options) {
				this.provinceAbbr=options.text
				this.isOpen = false
				console.log(options)
			},
			
			selectOption(options) {
				this.selectedOption = options;
				this.isOpen = false
			},
			sqlist() {
				if (this.ValueType == 1 || this.ValueType == 2 || this.ValueType == 4) {
					if (this.ValueType == 4) {
						if (this.activityId == '' || this.idCard == '' || this.name == '') {
							this.$message({
								message: '请输入信息后查询',
								type: 'warning'
							});
							return true
						}
					} else if (this.ValueType == 1) {
						if (this.ValueSearchType == 1) {
							if (this.code == '') {
								this.$message({
									message: '请输入作品编号后查询',
									type: 'warning'
								});
								return true
							}
						}
						if (this.ValueSearchType == 2) {
							if (this.idCard == '' || this.name == '') {
								this.$message({
									message: '请输入信息后查询',
									type: 'warning'
								});
								return true
							}
						}
					} else if (this.ValueType == 2) {
						if (this.code == '') {
							this.$message({
								message: '请输入实践证书编号后查询',
								type: 'warning'
							});
							return true
						}
					}
					this.list = []
					this.issq = false;
					this.loading = true;
					this.getWorkMsgBt()
				} else if (this.ValueType == 3) {
					// if (this.teacherName == '' || this.tel == '') {
					// 		this.$message({
					// 			message: '请输入信息后查询',
					// 			type: 'warning'
					// 		});
					// 		return true
					// 	}
					if (this.certNo == '') {
							this.$message({
								message: '请输入信息后查询',
								type: 'warning'
							});
							return true
						}
					this.getcertQueryBT()
				}
				/* if (this.ValueType == 2) {
					this.getWorkMsgBt()
					// this.$message({
					//   message: '暂未开放',
					//   type: 'warning'
					// }); 
				} else if (this.ValueType == 3) {
					// this.$message({
					//   message: '暂未开放',
					//   type: 'warning'
					// });
					this.getcertQueryBT()
				} */
			},
			// 活动列表数据
			onLoadActivity() {
				this.swActivity = []
				getPageActivity({
					pageNo: 1,
					pageSize: 100
				}).then((res) => {
					if (res.success) {
						this.swActivity = res.data.records
					}
				});
			},
			getWorkMsgBt() {
				getWorksMsg({
					code: this.code,
					type: this.ValueType,
					idCard: this.idCard,
					name: this.name,
					provinceAbbr: this.provinceAbbr,
					activityId: this.activityId
				}).then(
					// getWorkMsg(this.value).then(
					(res) => {
						if (res.success) {
							if (res.data != null) {
								this.list = res.data
								this.issq = true
								this.loading = false;
							} else {
								this.issq = true
								this.loading = false;
								this.list = []
							}
						} else {
							this.loading = false;
						}
					}).catch(err => {
					this.loading = false;
				})
			},
			/**
			 * @description: 教师证书
			 * @author: wangxiaoheng
			 */
			getcertQueryBT() {
				getcertsQuery({
					certNo:this.certNo,
					// tel: this.tel,
					// teacherName: this.teacherName,
				}).then(res => {
					console.log(res.data)
					if (res.success) {
						if (res.data != null) {
							let data = res.data
							if (!data.works || data.works.length < 1) {
								data.works = [{
									babyName: '张塞'
								}]
							}
							this.list = res.data
							this.issq = true
							this.loading = false;
						} else {
							this.issq = true
							this.loading = false;
							this.list = []
						}
					} else {
						this.loading = false;
					}
				}).catch(err => {
					this.loading = false;
				})
			},


			//查看作品
			onPreview(row) { // 开启大图查看器
				this.imageUrl = []
				getWorksDetailsByH5(row.id).then(
					(res) => {
						if (res.success) {
							if (res.data != null) {
								this.showViewer = true;
								this.imageUrl = getfileTypeArr(res.data.imgs)
							} else {
								this.$message({
									message: '暂无作品',
									type: 'warning'
								});
							}
						}
					})
			},
			//查看证书
			onPreviewprize(row) {
				this.imageUrl = []
				getWorksCertificateByH5(row.id).then(
					(res) => {
						if (res.success) {
							if (res.data != null) {
								this.showViewer = true;
								this.imageUrl.push(res.data.certUrl)
							} else {
								this.$message({
									message: '暂无证书',
									type: 'warning'
								});
							}
						}
					})
			},
			// 关闭图片查看器
			closeViewer() {
				this.showViewer = false;
			},
			/**
			 * @description:  查看文件
			 * @param {*} ks
			 * @return {*}
			 * @author: wangxiaoheng
			 */
			getcheck(ks) {
				this.checkData = ks;
				this.checkType = true;
			},
			/**
			 * @description: 关闭音视频
			 * @param {*} index
			 * @author: wangxiaoheng
			 */
			beforeCloseHandler() {
				if (this.$refs.audioPlayer) {
					this.$refs.audioPlayer.pause();
					this.$refs.audioPlayer.currentTime = 0;
				}
				if (this.$refs.videoPlayer) {
					this.$refs.videoPlayer.pause();
					this.$refs.videoPlayer.currentTime = 0;
				}
			},

		}
	}
</script>

<style scoped lang="scss">
	.hello {
		padding-top: 1px;
		min-height: 100vh;
		background-color: #F7F7FA;
		background-image: url(../../assets/images/chaxun_bg.png);
		background-size: 100% 187px;
		background-repeat: no-repeat;
	}

	.queryBox {
		// width: 345px;
		// height: 160px;
		background: #FFFFFF;
		border-radius: 6px;
		margin: auto;
		margin-top: 141px;
		padding-left: 15px;
		// padding-top: 18px;
		padding-right: 15px;
	}

	.queryBoxHeight {
		// height: 190px;
	}

	.queryBox-title {

		text-align: left;
		font-weight: bold;
		font-size: 16px;
		color: #404046;
		padding-top: 20px;
	}

	.queryValue {
		margin-top: 10px;
		padding-bottom: 5px;
		justify-content: space-between;

		div {
			// width: 75px;
			// height: 55px;
			background: #FFFFFF;
			border: 1px solid #D6DBE0;
			border-radius: 7px;
			font-size: 13px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #8E8E94;
			margin-right: 15px;
			width: 100%;
			padding: 9px 0;
		}

		div:last-child {
			margin-right: 0px;
		}
	}

	.queryValue2 {
		div {
			font-size: 14px;
		}
	}

	.input_box_border {
		margin-top: 20px;
		border-top: 1px solid #EEF1F5;
	}

	.inputwidth {

		padding-top: 20px;


		:deep(.van-cell) {
			// padding-left: 0px;
			// padding-right: 0px;
			border: 1px solid #D6DBE0;
			border-radius: 7px;
			padding: 10px 16px;
			font-size: 14px;
			line-height: normal;

			.van-field__control:read-only {
				padding-right: 30px;
			}
		}

		.input_panel {
			padding-bottom: 15px;
			position: relative;

			.van-icon {
				color: #C9C9C9;
				font-size: 16px;
				position: absolute;
				right: 16px;
				top: 11px;
				z-index: 2;
			}
		}

		.input_title {
			font-size: 14px;
			color: #646566;
		}

		.input_select {
			box-sizing: border-box;
			width: 60px;
			height: 29px;
			background: #FFFFFF;
			border-radius: 5px;
			border: 1px solid #D6DBE0;
			padding-left: 13px;
			padding-right: 9px;
		}
	}

	.inputwidth0 {
		margin-top: 0px;
		border-top: 0px solid #EEF1F5;
	}

	.van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border-width: 0 0;
	}

	.btn {
		width: 345px;
		height: 40px;
		background: #9FA3AD;
		border-radius: 20px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #FFFFFF;
		margin: 0 auto;
		margin-top: 20px;
	}

	.btn-Selected {
		background: #63D579;
	}

	.query-Selected {
		color: #FF7856 !important;
		border: 1px solid #FF7856 !important;
		background: rgba(255, 120, 86, 0.1) !important;
		position: relative;

		&::after {
			content: '';
			display: inline-block;
			width: 20px;
			height: 20px;
			background: url(../../assets/images/icon_choose.png) no-repeat center 100%;
			background-size: 100%;
			position: absolute;
			bottom: 0;
			right: 0;

		}
	}

	.worksLi {
		width: 90%;
		margin: 30px auto;
		border-radius: 10px;
		box-shadow: 4px 3px 20px #ddd9d9;
		background-color: #ffffff;

		p {
			min-height: 32px;
			background: rgba(86, 159, 255, 0.1);
			border-top-left-radius: 6px;
			border-top-right-radius: 6px;
			font-size: 13px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #569FFF;
		}
	}

	.filelist {
		width: 300px;
		height: 369px;
		background: #FFFFFF;
		border-radius: 6px;
	}

	.filelist-card {
		width: 270px;
		height: 45px;
		background: rgba(86, 159, 255, 0.1);
		border-radius: 6px;
		margin: 0 auto;
		margin-top: 15px;
	}

	.filelist-card-name {
		width: 70px;
		margin-left: 12px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 400;
		color: #8E8E94;
	}

	.filelist-card-value {
		width: 120px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #404046;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.filelist-card-btn {
		margin-right: 10px;
		font-size: 14px;
		font-family: PingFang SC;
		font-weight: 500;
		color: #569FFF;
	}

	.filelist-title {
		margin-top: 15px;
		font-size: 18px;
		font-family: PingFang SC;
		font-weight: bold;
		color: #404046;
	}

	.douyin_img {
		width: 35%;
		vertical-align: middle;
		margin-bottom: 50px;
	}
</style>
<style lang="scss">
	.bmcx {
		.van-popup.photo-tags2 {
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: unset;
		}

		.van-popup.photo-tags {
			background-color: unset;

			.checkClass {
				width: 8.1067rem;
				border-radius: 0.4267rem;
				overflow: hidden;
				margin-top: 5vh;
				display: flex;
			}

			.show-photo-tags {
				height: 100%;
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				flex-direction: column;
				overflow: hidden;

				p {
					font-size: 14px;
					text-align: center;
					color: #f2f2f2;
				}

				img {
					width: 304px;
					border-radius: 16px;
					overflow: hidden;
					margin-top: 5vh;
					display: flex;
				}
			}
		}
	}

	.worksLi {
		.labelclass {
			text-align: center !important;
			background-color: #ffffff;
		}

		.contentClass {
			max-width: 150px;
			text-align: right !important;
		}

		.el-descriptions .is-bordered .el-descriptions-item__cell {
			border-width: 0 0;
		}
	}

	.custom-select {
		position: relative;

		.selected-option {
			box-sizing: border-box;
			// width: 60px;
			// height: 29px;
			background: #FFFFFF;
			// border-radius: 7px;
			// padding-left: 13px;
			// padding-right: 9px;
			// border: 1px solid #D6DBE0;
			// font-family: PingFang SC;
			// font-weight: 500;
			// font-size: 13px;
			color: #8E8E94;
			cursor: pointer;


			border: 1px solid #D6DBE0;
			border-radius: 7px;
			padding: 10px 16px;
			font-size: 14px;
		}

		.options-container {
			position: absolute;
			width: 100%;
			max-height: 250px;
			overflow-y: auto;
			display: flex;
			flex-direction: column;
			background-color: #fff;
			border: 1px solid #D6DBE0;
			border-radius: 5px;
			z-index: 10;
		}

		.caret_img {
			width: 10px;
			height: 6px;
			transform: rotate(-90deg)
		}

		.caret_imgSelect {
			animation-name: rotateDown;
			/* 引用上面定义的动画名称 */
			animation-duration: 0.2s;
			/* 动画持续时间，这里是1秒 */
			animation-timing-function: ease-in-out;
			/* 动画速度曲线 */
			animation-fill-mode: forwards;
			/* 动画结束后保持最后一个关键帧的状态 */
		}

		@keyframes rotateDown {
			0% {
				transform: rotate(-90deg);
				/* 初始状态，未旋转 */
			}

			100% {
				transform: rotate(0deg);
				/* 结束状态，旋转90度 */
			}
		}

		.option {
			color: #000000;
			padding: 10px;
			font-size: 13px;
			cursor: pointer;
		}

		.optionSelect {
			background-color: #c9c9c9;
		}

		.option:hover {
			/* 悬停时的样式 */
			background-color: #c9c9c9;
		}
	}
</style>